import styled from 'styled-components';

export const ErrorText = styled.span`
  margin-top: 0.5em;
  color: red;
  height: 1em;
`;
